<script setup lang="ts">
import { usersService } from "@/services/users-service";
import { onBeforeMount, ref } from "vue";
import { TableColumn } from "@/models/table-column.ts";
import AppTable from "@/components/app-table.vue";
import type { EntraUserDTO } from "@/models/dtos/entra-user-dto.ts";
import { notificationsService } from "@/services/notifications-service.ts";
import { mdiThumbUp } from "@mdi/js";
import { invitationService } from "@/services/invitation-service.ts";

const pageLoading = ref(false);
const users = ref<EntraUserDTO[]>([]);

const entraColumns = ref([
  TableColumn.for("id", "Id"),
  TableColumn.for("displayName", "DisplayName"),
  TableColumn.for("userPrincipalName", "UserPrincipalName"),
  TableColumn.for("mail", "Email"),
  TableColumn.for("approve", "Skicka inbjudan", { sort: false }),
]);

onBeforeMount(async () => {
  try {
    pageLoading.value = true;
    users.value = await usersService.getEntraUsers();
  } catch (error) {
    notificationsService.open({
      text: "Något gick fel vid hämtning av inbjudningarna.",
      type: "error",
      error,
    });
  } finally {
    pageLoading.value = false;
  }
});

async function inviteUser(invitation: EntraUserDTO) {
  try {
    await invitationService.reinviteUser(invitation);
  } catch (error) {
    const t = error as { text: string };
    notificationsService.open({
      text: t.text, // 'Något gick fel vid inbjudning av användaren.',
      type: "error",
      error,
    });
  } finally {
    users.value = users.value.filter((i) => i.id !== invitation.id);
  }
}
</script>

<template>
  <section
    v-if="!pageLoading"
    class="section notification has-background-aero-light"
  >
    <app-table :columns="entraColumns" :items="users" :loading="pageLoading">
      <template #column:approve="{ item }">
        <button
          class="button is-success is-light"
          :class="{ 'is-loading': pageLoading }"
          @click="inviteUser(item)"
        >
          <span class="icon">
            <app-icon :icon="mdiThumbUp" size="16" />
          </span>
          <span>Godkänn</span>
        </button>
      </template>
    </app-table>
  </section>
</template>
